import { capitalize } from "../../name-helpers/nameFormatter"
import { getPriceListName } from "../../name-helpers/priceListNameHelper"
import { FormattedMessage, injectIntl } from "react-intl"
import React from "react"
import {Intl} from "../../state/helpers/IntlProps"

type Props = {
    intl: Intl
}

const PriceListMenuMessage = (props: Props) => {
    const priceListName = getPriceListName(props.intl)
    const capitalizedPriceListName = capitalize(priceListName)
    return (
        <FormattedMessage
            id="main.menu.price_list_label"
            defaultMessage="{priceList}s"
            values={{
                priceList: capitalizedPriceListName
            }}
        />
    )
}

export default injectIntl(PriceListMenuMessage)


// WEBPACK FOOTER //
// ./src/common/layout/PriceListMenuMessage.tsx